var React = require('react');

function MenuArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L5 5L9 1","stroke":"#02291C","strokeLinecap":"round","strokeLinejoin":"round"}));
}

MenuArrowInline.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none"};

module.exports = MenuArrowInline;

MenuArrowInline.default = MenuArrowInline;
